import { render, staticRenderFns } from "./PermanentDisabilityBenefit.vue?vue&type=template&id=68a285a8"
import script from "./PermanentDisabilityBenefit.vue?vue&type=script&lang=js"
export * from "./PermanentDisabilityBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports